import { render, staticRenderFns } from "./lifeSciences.vue?vue&type=template&id=815cdbc8"
import script from "./lifeSciences.vue?vue&type=script&lang=js"
export * from "./lifeSciences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports